export const HERO_ROLES = [
  "designers",
  "writers",
  "filmmakers",
  "strategists",
  "engineers",
  "AI explorers",
  "rebels",
];
